/* eslint-disable react-hooks/rules-of-hooks */
import JsBarcode from 'jsbarcode';
import jsPDF from 'jspdf';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

export const DISCOUNT = {
   DISCOUNT_PERCENT1: 'addLess1Percent',
   DISCOUNT_PERCENT2: 'addLess2Percent',
   DISCOUNT_PERCENT3: 'addLess3Percent',
};

export const ACCOUNT_TYPE = {
   CUSTOMER: 'K',
   VENDOR: 'E',
};

export const DAYBOOK_TYPE = {
   BANK: 14,
   CASH: 13,
};

export const GL_GROUP_TYPE = {
   CUSTOMER: 18,
   VENDOR: 12,
};

export const stocktype = [
   { id: 1, name: 'STORE STOCK' },
   { id: 2, name: 'REPAIRING STOCK' },
];

export const REPORT_TYPE_OPTIONS = [
   { value: 'date', label: 'Date' },
   { value: 'party', label: 'Party' },
   { value: 'broker', label: 'Broker' },
];

export const FORMAT_TYPE = [
   { value: 'with_item_detail', label: 'With Item Detail' },
   { value: 'without_item_detail', label: 'Without Item Detail' },
];

export const storeStockType = [
   { id: 1, name: 'ALL' },
   { id: 2, name: 'ONLY RECEIVED' },
   { id: 3, name: 'STORE ISSUED' },
   { id: 4, name: 'PARTY ISSUED' },
   { id: 5, name: 'STORE REPAIRING RECEIVED' },
   { id: 7, name: 'PARTY PENDING SALES' },
   { id: 8, name: 'PARTY REPAIRING SOLD' },
];

export const transactionType = [
   { id: 1, name: 'ALL' },
   { id: 2, name: 'Purchase Transaction' },
   { id: 3, name: 'Purchase Return Transaction' },
   { id: 4, name: 'Sales Transaction' },
   { id: 5, name: 'Sales Return Transaction' },
   { id: 6, name: 'Receive Transaction' },
   { id: 7, name: 'Issue Transaction' },
   { id: 8, name: 'Cash Receive Transaction' },
   { id: 9, name: 'Cash Payment Transaction' },
   { id: 10, name: 'Bank Receive Transaction' },
   { id: 11, name: 'Bank Payment Transaction' },
   { id: 12, name: 'Journal Voucher Transaction' },
   { id: 13, name: 'Transaction Summary' },
   { id: 14, name: 'Daily Summary' },
];

export const GST_TXN_TYPE = {
   None: 0,
   B2B: 1,
   B2C: 2,
   Exports: 3,
   Imports: 4,
   Unregistered: 5,
};

export const GST_SUB_TXN_TYPE = {
   None: 0,
   IntraState: 1,
   InterState: 2,
   IntraUT: 3,
   NormalExport: 4,
   SezExport: 5,
   DeemedExport: 6,
   NormalImport: 7,
   SezImport: 8,
};

export const REPORT_TYPE = {
   party: 'party',
};

export const ORDER_BY_OPTIONS = [
   { label: 'Descending', value: 'desc' },
   { label: 'Ascending', value: 'asc' },
];

export const stockDrop = [
   { id: 0, name: 'Item + Serial-Wise' },
   { id: 1, name: 'Item-wise' },
   { id: 2, name: 'Serial-Wise' },
];

export const stockStatusDrop = [
   { id: 0, name: 'All' },
   { id: 1, name: 'Completed' },
   { id: 2, name: 'Pending' },
];

export const osTypeOptions = [
   { value: 0, label: 'Sale' },
   { value: 1, label: 'Purchase' },
];

export const functionNameOptions = [
   { id: 0, value: 'Bank Payment', label: 'Bank Payment' },
   { id: 1, value: 'Bank Receipt', label: 'Bank Receipt' },
   { id: 2, value: 'Cash Payments', label: 'Cash Payments' },
   { id: 3, value: 'Cash Receipts', label: 'Cash Receipts' },
   { id: 4, value: 'Credit Notes', label: 'Credit Notes' },
   { id: 5, value: 'Debit Notes', label: 'Debit Notes' },
   { id: 6, value: 'Inventory Issues', label: 'Inventory Issues' },
   { id: 7, value: 'Inventory Receipts', label: 'Inventory Receipts' },
   { id: 8, value: 'Journal Voucher', label: 'Journal Voucher' },
   { id: 9, value: 'Purchase Challans', label: 'Purchase Challans' },
   { id: 10, value: 'Purchase Enquiries', label: 'Purchase Enquiries' },
   { id: 11, value: 'Purchase Invoices', label: 'Purchase Invoices' },
   { id: 12, value: 'Purchase Orders', label: 'Purchase Orders' },
   { id: 13, value: 'Purchase Quotes', label: 'Purchase Quotes' },
   { id: 14, value: 'Purchase Returns', label: 'Purchase Returns' },
   { id: 15, value: 'Sales Challans', label: 'Sales Challans' },
   { id: 16, value: 'Sales Enquiry', label: 'Sales Enquiry' },
   { id: 17, value: 'Sales Invoice', label: 'Sales Invoice' },
   { id: 18, value: 'Sales Order', label: 'Sales Order' },
   { id: 19, value: 'Sales Quote', label: 'Sales Quote' },
   { id: 20, value: 'Sales Return', label: 'Sales Return' },
];

export const USER_TYPE_OPTIONS = [
   { id: 0, label: 'USER' },
   { id: 1, label: 'SALESMAN' },
   { id: 2, label: 'SERVICE' },
   { id: 3, label: 'ACCOUNT' },
   { id: 4, label: 'CHECKING' },
   { id: 5, label: 'REPAIRING' },
   { id: 6, label: 'ADMIN' },
   { id: 7, label: 'VERIFICATION' },
   { id: 8, label: 'ADVERTISEMENT' },
   { id: 9, label: 'E-COMMERCE MANAGER' },
];

export const USER_TYPES = {
   ADMIN: 0,
   SALESMAN: 1,
   SERVICE: 2,
   ACCOUNT: 3,
   CHECKING: 4,
   REPAIRING: 5,
};

export const SALE_FILTER = {
   SALE_INVOICE: 5,
   PURCHASE_INVOICE: 13,
   SALE_RETURN: 6,
   PURCHASE_RETURN: 3,
};

export const fontFamilyOptions = [
   'Arial',
   'Helvetica',
   'Times New Roman',
   'Georgia',
   'Verdana',
   'Trebuchet MS',
   'Courier New',
   'Impact',
   'Comic Sans MS',
   'Palatino',
   'Anek Gujarati',
   'noto serif',
];

export const fontWeightOptions = [
   { value: 'normal', label: 'Normal' },
   { value: 'bold', label: 'Bold' },
   { value: '100', label: 'Thin' },
   { value: '300', label: 'Light' },
   { value: '500', label: 'Medium' },
   { value: '600', label: 'Semi Bold' },
   { value: '700', label: 'Bold' },
   { value: '800', label: 'Extra Bold' },
   { value: '900', label: 'Black' },
];

export const fontStyleOptions = [
   { value: 'normal', label: 'Normal' },
   { value: 'italic', label: 'Italic' },
   { value: 'oblique', label: 'Oblique' },
];

export const textDecorationOptions = [
   { value: 'none', label: 'None' },
   { value: 'underline', label: 'Underline' },
   { value: 'line-through', label: 'Strikethrough' },
   { value: 'overline', label: 'Overline' },
];

export const textTransformOptions = [
   { value: 'none', label: 'None' },
   { value: 'uppercase', label: 'UPPERCASE' },
   { value: 'lowercase', label: 'lowercase' },
   { value: 'capitalize', label: 'Capitalize' },
];

export const wordWrapOptions = [
   { value: 'normal', label: 'Normal' },
   { value: 'break-word', label: 'Break Word' },
   { value: 'break-all', label: 'Break All' },
];

export const whiteSpaceOptions = [
   { value: 'nowrap', label: 'No Wrap' },
   { value: 'normal', label: 'Normal' },
   { value: 'pre-wrap', label: 'Preserve Wrap' },
   { value: 'pre', label: 'Preserve' },
];

export const PAPER_SIZES = {
   a3: { width: 297, height: 420, label: 'A3 (297 × 420 mm)' },
   a4: { width: 210, height: 297, label: 'A4 (210 × 297 mm)' },
   a5: { width: 148, height: 210, label: 'A5 (148 × 210 mm)' },
   a6: { width: 105, height: 148, label: 'A6 (105 × 148 mm)' },
   b3: { width: 353, height: 500, label: 'B3 (353 × 500 mm)' },
   b4: { width: 250, height: 353, label: 'B4 (250 × 353 mm)' },
   b5: { width: 176, height: 250, label: 'B5 (176 × 250 mm)' },
   letter: { width: 215.9, height: 279.4, label: 'Letter (8.5" × 11")' },
   legal: { width: 215.9, height: 355.6, label: 'Legal (8.5" × 14")' },
   statement: { width: 139.7, height: 215.9, label: 'Statement (5.5" × 8.5")' },
   executive: { width: 184.1, height: 266.7, label: 'Executive (7.25" × 10.5")' },
   'envelope-monarch': { width: 98.4, height: 190.5, label: 'Envelope Monarch' },
   'envelope-10': { width: 104.8, height: 241.3, label: 'Envelope No. 10 (COM10)' },
   'envelope-dl': { width: 110, height: 220, label: 'Envelope DL' },
   'envelope-c5': { width: 162, height: 229, label: 'Envelope C5' },
   'index-card': { width: 76.2, height: 127, label: 'Index Card (3" × 5")' },
   custom: { width: 210, height: 297, label: 'Custom (Name Fixed)' },
};

export const convertToPixels = (value, unit, dpi = 72) => {
   switch (unit) {
      case 'mm':
         return Math.round((value * dpi) / 25.4);
      case 'cm':
         return Math.round((value * 10 * dpi) / 25.4);
      case 'inch':
         return Math.round(value * dpi);
      case 'px':
         return Math.round(value);
      default:
         return Math.round(value);
   }
};

export const convertFromPixels = (pixels, unit, dpi = 72) => {
   switch (unit) {
      case 'mm':
         return Math.round(((pixels * 25.4) / dpi) * 100) / 100;
      case 'cm':
         return Math.round(((pixels * 25.4) / (dpi * 10)) * 100) / 100;
      case 'inch':
         return Math.round((pixels / dpi) * 100) / 100;
      case 'px':
         return Math.round(pixels);
      default:
         return Math.round(pixels);
   }
};

export const getPageWidth = (pageData) => {
   const { pageSize, orientation, customWidth, customUnit } = pageData;
   let width;

   if (pageSize === 'custom') {
      width = convertToPixels(customWidth, customUnit || 'mm');
   } else {
      const paperSize = PAPER_SIZES[pageSize];
      if (paperSize) {
         width = convertToPixels(paperSize.width, 'mm');
      } else {
         width = 595; // Default A4 width
      }
   }

   // For landscape, swap width and height for predefined sizes
   if (orientation === 'landscape' && pageSize !== 'custom') {
      const height = getPageHeight({ ...pageData, orientation: 'portrait' });
      return height;
   }

   return width;
};

export const getPageHeight = (pageData) => {
   const { pageSize, orientation, customHeight, customUnit } = pageData;

   let height;

   if (pageSize === 'custom') {
      height = convertToPixels(customHeight, customUnit || 'mm');
   } else {
      const paperSize = PAPER_SIZES[pageSize];
      if (paperSize) {
         height = convertToPixels(paperSize.height, 'mm');
      } else {
         height = 842; // Default A4 height
      }
   }

   // For landscape, swap width and height for predefined sizes
   if (orientation === 'landscape' && pageSize !== 'custom') {
      const width = getPageWidth({ ...pageData, orientation: 'portrait' });
      return width;
   }

   return height;
};

export const generateBarcodeCanvas = (value, options = {}) => {
   const canvas = document.createElement('canvas');
   const ctx = canvas.getContext('2d');
   const {
      width = 200,
      height = 50,
      barWidth = 2,
      foregroundColor = '#000000',
      backgroundColor = '#FFFFFF',
      showText = true,
      fontSize = 10,
   } = options;

   canvas.width = width;
   canvas.height = height;

   // Fill background
   ctx.fillStyle = backgroundColor;
   ctx.fillRect(0, 0, width, height);

   // Generate barcode pattern
   const barcodeValue = value || '123456789012';
   const bars = [];

   // Create simple pattern based on barcode value
   for (let i = 0; i < barcodeValue.length; i++) {
      const digit = parseInt(barcodeValue[i]) || 0;
      for (let j = 0; j < 8; j++) {
         const isBar = (digit + j) % 2 === 0;
         const barWidthPx = ((digit % 3) + 1) * barWidth;
         bars.push({
            width: barWidthPx,
            height: showText ? height - fontSize - 4 : height,
            isBar: isBar,
         });
      }
   }

   // Limit number of bars to fit width
   const totalBars = bars.slice(0, Math.floor(width / barWidth));

   // Draw bars
   ctx.fillStyle = foregroundColor;
   let currentX = 0;
   totalBars.forEach((bar) => {
      if (bar.isBar && currentX + bar.width <= width) {
         ctx.fillRect(currentX, 0, bar.width, bar.height);
      }
      currentX += bar.width + 1; // 1px spacing
   });

   // Draw text if enabled
   if (showText) {
      ctx.fillStyle = foregroundColor;
      ctx.font = `${fontSize}px monospace`;
      ctx.textAlign = 'center';
      ctx.fillText(barcodeValue, width / 2, height - 2);
   }

   return canvas.toDataURL('image/png');
};

// Helper function to convert hex colors to RGB
const hexToRgb = (hex) => {
   if (!hex) return [0, 0, 0];

   const namedColors = {
      transparent: [255, 255, 255],
      black: [0, 0, 0],
      white: [255, 255, 255],
      red: [255, 0, 0],
      green: [0, 255, 0],
      blue: [0, 0, 255],
   };

   if (namedColors[hex.toLowerCase()]) {
      return namedColors[hex.toLowerCase()];
   }

   hex = hex.replace('#', '');

   if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
   }

   if (hex.length !== 6) {
      return [0, 0, 0];
   }

   const r = parseInt(hex.substr(0, 2), 16);
   const g = parseInt(hex.substr(2, 2), 16);
   const b = parseInt(hex.substr(4, 2), 16);

   return [isNaN(r) ? 0 : r, isNaN(g) ? 0 : g, isNaN(b) ? 0 : b];
};

// Custom hook for PDF generation
export const usePDFGenerator = () => {
   const [previewElements, setPreviewElements] = useState([]);
   const [isGenerating, setIsGenerating] = useState(false);
   const setupPrintSingle = useSelector((state) => state.setupPrint.result || []);

   const generatePDFBlob = async () => {

      setIsGenerating(true);

      try {
         // Check if previewElements is an empty array or undefined
         if (!previewElements || (Array.isArray(previewElements) && previewElements.length === 0)) {
            console.error('ERROR: previewElements is empty or undefined');
            throw new Error('No preview elements available. Please create a document first.');
         }

         // Handle case where previewElements might be an array instead of object
         let elements = [];
         let pageConfig = {};

         if (Array.isArray(previewElements)) {
            // If previewElements is an array, use it directly as elements
            elements = previewElements;
            pageConfig = {
               pageWidth: 595, // Default A4 width
               pageHeight: 842, // Default A4 height
               orientation: 'portrait',
            };
         } else if (previewElements.elements && Array.isArray(previewElements.elements)) {
            // If previewElements is an object with elements array
            elements = previewElements.elements;
            pageConfig = {
               pageWidth: previewElements.pageWidth || 595,
               pageHeight: previewElements.pageHeight || 842,
               orientation: previewElements.orientation || 'portrait',
            };
         } else {
            console.error('ERROR: previewElements has invalid format:', previewElements);
            throw new Error('Preview elements are not properly formatted');
         }

         // Check if we have any elements to render
         if (elements.length === 0) {
            console.error('ERROR: No elements to render');
            throw new Error('No content to generate PDF. Please add elements to your document.');
         }

         // Get page dimensions
         const pageWidth = pageConfig.pageWidth;
         const pageHeight = pageConfig.pageHeight;

         // Determine orientation for jsPDF
         const orientation = pageConfig.orientation === 'landscape' ? 'l' : 'p';

         // Create custom page format
         const pageFormat = [pageWidth, pageHeight];

         const doc = new jsPDF(orientation, 'pt', pageFormat);

         // Process non-table elements first with safe filtering
         const nonTableElements = elements.filter((el) => el && el.type !== 'table');
         const tableElements = elements.filter((el) => el && el.type === 'table');
         // If no elements to render, create a simple PDF
         if (nonTableElements.length === 0 && tableElements.length === 0) {
            doc.setFontSize(16);
            doc.text('No content available', 20, 20);
            return doc.output('blob');
         }

         // Helper function to determine text wrapping behavior
         const getTextWrapBehavior = (element) => {
            // If wordWrap is set to 'break-word', allow wrapping
            if (element.wordWrap === 'break-word') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: true,
               };
            }
            // For specific element types that should wrap by default
            if (element.type === 'client' || element.type === 'notes') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: false,
               };
            }
            // For custom whiteSpace settings
            if (element.whiteSpace === 'pre-wrap') {
               return {
                  shouldWrap: true,
                  preserveLineBreaks: true,
                  breakWords: element.wordWrap === 'break-word',
               };
            }
            // Default behavior - no wrapping
            return {
               shouldWrap: false,
               preserveLineBreaks: false,
               breakWords: false,
            };
         };

         // Helper function to wrap text for PDF
         const wrapText = (text, maxWidth, fontSize, fontStyle = 'normal') => {
            doc.setFontSize(fontSize);
            doc.setFont(undefined, fontStyle);
            const lines = [];
            const paragraphs = text.split('\n');
            paragraphs.forEach((paragraph) => {
               if (paragraph.trim() === '') {
                  lines.push('');
                  return;
               }
               const words = paragraph.split(' ');
               let currentLine = '';
               words.forEach((word) => {
                  const testLine = currentLine + (currentLine ? ' ' : '') + word;
                  const testWidth = doc.getTextWidth(testLine);
                  if (testWidth <= maxWidth) {
                     currentLine = testLine;
                  } else {
                     if (currentLine) {
                        lines.push(currentLine);
                        currentLine = word;
                     } else {
                        // Word is too long, break it
                        lines.push(word);
                     }
                  }
               });
               if (currentLine) {
                  lines.push(currentLine);
               }
            });
            return lines;
         };

         // Function to render all non-table elements
         const renderStaticContent = (pageNum = 1) => {
            nonTableElements.forEach((element) => {
               const x = element.x;
               const y = element.y;
               const fontSize = element.fontSize;

               doc.setFontSize(fontSize);
               doc.setTextColor(element.color);

               if (element.fontWeight === 'bold') {
                  doc.setFont(undefined, 'bold');
               } else {
                  doc.setFont(undefined, 'normal');
               }

               // Handle different element types (image, line, text)
               if (element.type === 'image' && element.src) {
                  try {
                     let imageData = element.src;
                     if (element.src.startsWith('data:')) {
                        imageData = element.src;
                     }

                     const imgProps = doc.getImageProperties(imageData);
                     const pdfWidth = element.width;
                     const pdfHeight = element.height;

                     let finalWidth = pdfWidth;
                     let finalHeight = pdfHeight;
                     let offsetX = 0;
                     let offsetY = 0;

                     if (element.objectFit === 'contain') {
                        const imgRatio = imgProps.width / imgProps.height;
                        const containerRatio = pdfWidth / pdfHeight;

                        if (imgRatio > containerRatio) {
                           finalHeight = pdfWidth / imgRatio;
                           offsetY = (pdfHeight - finalHeight) / 2;
                        } else {
                           finalWidth = pdfHeight * imgRatio;
                           offsetX = (pdfWidth - finalWidth) / 2;
                        }
                     } else if (element.objectFit === 'cover') {
                        const imgRatio = imgProps.width / imgProps.height;
                        const containerRatio = pdfWidth / pdfHeight;

                        if (imgRatio > containerRatio) {
                           finalWidth = pdfHeight * imgRatio;
                           offsetX = (pdfWidth - finalWidth) / 2;
                        } else {
                           finalHeight = pdfWidth / imgRatio;
                           offsetY = (pdfHeight - finalHeight) / 2;
                        }
                     }

                     if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                        const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                        doc.setFillColor(bgR, bgG, bgB);
                        doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                     }

                     if (element.borderWidth > 0) {
                        const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                        doc.setDrawColor(borderR, borderG, borderB);
                        doc.setLineWidth(element.borderWidth);

                        if (element.borderStyle === 'dashed') {
                           doc.setLineDash([3, 3]);
                        } else if (element.borderStyle === 'dotted') {
                           doc.setLineDash([1, 1]);
                        } else {
                           doc.setLineDash([]);
                        }

                        if (element.borderRadius > 0) {
                           doc.roundedRect(x, y, pdfWidth, pdfHeight, element.borderRadius, element.borderRadius, 'S');
                        } else {
                           doc.rect(x, y, pdfWidth, pdfHeight, 'S');
                        }
                     }

                     let imageFormat = 'JPEG';
                     if (imageData.includes('data:image/png')) {
                        imageFormat = 'PNG';
                     } else if (imageData.includes('data:image/gif')) {
                        imageFormat = 'GIF';
                     } else if (imageData.includes('data:image/webp')) {
                        imageFormat = 'WEBP';
                     }

                     doc.addImage(
                        imageData,
                        imageFormat,
                        x + offsetX,
                        y + offsetY,
                        finalWidth,
                        finalHeight,
                        undefined,
                        'FAST',
                        element.rotation || 0,
                     );

                     if (element.overlay) {
                        const [overlayR, overlayG, overlayB] = hexToRgb(element.overlay.color || '#000000');
                        doc.setFillColor(overlayR, overlayG, overlayB);
                        doc.setGState(new doc.GState({ opacity: element.overlay.opacity || 0.5 }));
                        doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                        doc.setGState(new doc.GState({ opacity: 1 }));
                     }
                  } catch (error) {
                     console.error('Error adding image to PDF:', error);
                     const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                     doc.setFillColor(placeholderR, placeholderG, placeholderB);
                     doc.rect(x, y, element.width, element.height, 'F');
                     doc.setDrawColor(200, 200, 200);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, element.height, 'S');
                     doc.setDrawColor(150, 150, 150);
                     doc.setLineWidth(2);
                     doc.line(x + 10, y + 10, x + element.width - 10, y + element.height - 10);
                     doc.line(x + element.width - 10, y + 10, x + 10, y + element.height - 10);
                     doc.setFontSize(10);
                     doc.setTextColor(128, 128, 128);
                     doc.text('Image not available', x + 10, y + element.height / 2);
                  }
               } else if (element.type === 'line') {
                  const [lineR, lineG, lineB] = hexToRgb(element.color || '#000000');
                  doc.setDrawColor(lineR, lineG, lineB);
                  doc.setLineWidth(element.thickness || element.height || 1);

                  if (element.rotation) {
                     // For rotated lines, we need to calculate the end points
                     const radians = (element.rotation * Math.PI) / 180;

                     // Adjust starting point for vertical lines (90 degrees)
                     let startX = x;
                     let startY = y;

                     if (Math.abs(element.rotation) === 90) {
                        // For vertical lines, start from width/2 offset
                        startX = x + element.width / 2;
                     }

                     const endX = startX + element.width * Math.cos(radians);
                     const endY = startY + element.width * Math.sin(radians);
                     doc.line(startX, startY, endX, endY);
                  } else {
                     // Horizontal line
                     doc.line(x, y + element.height / 2, x + element.width, y + element.height / 2);
                  }
               } else if (element.type === 'barcode') {
                  try {
                     // Generate barcode using canvas instead of SVG
                     const generateBarcodeCanvas = (value, options = {}) => {
                        try {
                           const barcodeValue = value || '123456789012';
                           const canvas = document.createElement('canvas');
                           const ctx = canvas.getContext('2d');

                           // Set canvas dimensions based on element size
                           canvas.width = options.width || 200;
                           canvas.height = options.height || 60;

                           // Configure JsBarcode to render on canvas
                           JsBarcode(canvas, barcodeValue.toString(), {
                              format: options.format || 'CODE128',
                              width: options.barWidth || 1,
                              height: options.barHeight || 40,
                              displayValue: options.showText !== false,
                              fontSize: options.fontSize || 10,
                              marginTop: options.marginTop || 0,
                              textMargin: options.textMargin || 0,
                              background: options.backgroundColor || '#FFFFFF',
                              lineColor: options.foregroundColor || '#000000',
                           });

                           // Convert canvas to data URL (PNG format)
                           return canvas.toDataURL('image/png');
                        } catch (error) {
                           console.error('Error generating barcode canvas:', error);
                           return null;
                        }
                     };

                     // Calculate barcode dimensions
                     const barcodeHeight = element.barHeight || 40;
                     const textHeight = element.showText !== false ? (element.fontSize || 10) + 10 : 0;
                     const totalBarcodeHeight = barcodeHeight + textHeight;

                     // Generate barcode with proper options
                     const barcodeDataURL = generateBarcodeCanvas(
                        (setupPrintSingle[0] && setupPrintSingle[0][element.id]) ||
                        element.barcodeValue ||
                        element.content,
                        {
                           width: element.width,
                           height: totalBarcodeHeight,
                           format: element.barcodeFormat || 'CODE128',
                           barWidth: element.barWidth || 1,
                           barHeight: barcodeHeight,
                           foregroundColor: element.foregroundColor || '#000000',
                           backgroundColor: element.backgroundColor || '#FFFFFF',
                           showText: element.showText !== false,
                           fontSize: element.fontSize || 10,
                           marginTop: element.marginTop || 0,
                           textMargin: element.textMargin || 0,
                        },
                     );

                     if (!barcodeDataURL) {
                        throw new Error('Failed to generate barcode');
                     }

                     // Add background if specified
                     if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                        const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                        doc.setFillColor(bgR, bgG, bgB);
                        doc.rect(x, y, element.width, element.height, 'F');
                     }

                     // Add border if specified
                     if (element.borderWidth > 0) {
                        const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                        doc.setDrawColor(borderR, borderG, borderB);
                        doc.setLineWidth(element.borderWidth);

                        if (element.borderStyle === 'dashed') {
                           doc.setLineDash([3, 3]);
                        } else if (element.borderStyle === 'dotted') {
                           doc.setLineDash([1, 1]);
                        } else {
                           doc.setLineDash([]);
                        }

                        if (element.borderRadius > 0) {
                           doc.roundedRect(
                              x,
                              y,
                              element.width,
                              element.height,
                              element.borderRadius,
                              element.borderRadius,
                              'S',
                           );
                        } else {
                           doc.rect(x, y, element.width, element.height, 'S');
                        }
                     }

                     // Center the barcode vertically within the element
                     let barcodeY = y;
                     if (element.height > totalBarcodeHeight) {
                        barcodeY = y + (element.height - totalBarcodeHeight) / 2;
                     }

                     // Add the barcode image to PDF using PNG format
                     doc.addImage(
                        barcodeDataURL,
                        'PNG',
                        x,
                        barcodeY,
                        element.width,
                        totalBarcodeHeight,
                        undefined,
                        'FAST',
                     );
                  } catch (error) {
                     console.error('Error adding barcode to PDF:', error);

                     // Fallback: draw placeholder rectangle with text
                     const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                     doc.setFillColor(placeholderR, placeholderG, placeholderB);
                     doc.rect(x, y, element.width, element.height, 'F');
                     doc.setDrawColor(200, 200, 200);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, element.height, 'S');

                     // Add placeholder text
                     doc.setFontSize(10);
                     doc.setTextColor(128, 128, 128);
                     const barcodeText =
                        (setupPrintSingle[0] && setupPrintSingle[0]['barcodevalue']) ||
                        element.barcodeValue ||
                        element.content ||
                        'Barcode Error';
                     doc.text(barcodeText, x + element.width / 2, y + element.height / 2, { align: 'center' });
                  }
               } else {
                  // Handle text elements with enhanced wrapping
                  if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                     const [textBgR, textBgG, textBgB] = hexToRgb(element.backgroundColor);
                     doc.setFillColor(textBgR, textBgG, textBgB);
                     doc.rect(x, y, element.width, element.height, 'F');
                  }

                  if (element.borderWidth > 0) {
                     const [textBorderR, textBorderG, textBorderB] = hexToRgb(element.borderColor || '#000000');
                     doc.setDrawColor(textBorderR, textBorderG, textBorderB);
                     doc.setLineWidth(element.borderWidth);

                     if (element.borderStyle === 'dashed') {
                        doc.setLineDash([3, 3]);
                     } else if (element.borderStyle === 'dotted') {
                        doc.setLineDash([1, 1]);
                     } else {
                        doc.setLineDash([]);
                     }

                     if (element.borderRadius > 0) {
                        doc.roundedRect(
                           x,
                           y,
                           element.width,
                           element.height,
                           element.borderRadius,
                           element.borderRadius,
                           'S',
                        );
                     } else {
                        doc.rect(x, y, element.width, element.height, 'S');
                     }
                  }

                  doc.setFontSize(fontSize);
                  const fontStyle = element.fontWeight === 'bold' ? 'bold' : 'normal';
                  doc.setFont(undefined, fontStyle);

                  const [textR, textG, textB] = hexToRgb(element.color || '#000000');
                  doc.setTextColor(textR, textG, textB);

                  const lineHeight = element.lineHeight || 1.2;
                  const actualLineHeight = fontSize * lineHeight;

                  // Get text wrapping behavior
                  const wrapBehavior = getTextWrapBehavior(element);
                  const contentString =
                     element.content !== null && element.content !== undefined ? String(element.content) : '';
                  let lines;
                  if (wrapBehavior.shouldWrap) {
                     // Calculate available width for text
                     const availableWidth = element.width - (element.padding || 0) * 2;
                     lines = wrapText(contentString, availableWidth, fontSize, fontStyle);
                  } else {
                     // Use original line splitting for non-wrapping elements
                     lines = contentString.split('\n');
                  }

                  // Calculate vertical alignment offset
                  const totalTextHeight = lines.length * actualLineHeight;
                  const availableHeight = element.height - (element.padding || 0) * 2;
                  let verticalOffset = 0;

                  switch (element.verticalAlign) {
                     case 'top':
                        verticalOffset = 0;
                        break;
                     case 'middle':
                        verticalOffset = Math.max(0, (availableHeight - totalTextHeight) / 2);
                        break;
                     case 'bottom':
                        verticalOffset = Math.max(0, availableHeight - totalTextHeight);
                        break;
                     case 'baseline':
                        // For baseline, align to the baseline of the first line
                        verticalOffset = 0;
                        break;
                     default:
                        // Default to top alignment
                        verticalOffset = 0;
                        break;
                  }

                  lines.forEach((line, index) => {
                     let textX = x + (element.padding || 0);
                     let textOptions = {};

                     let displayText = line;
                     if (element.textTransform === 'uppercase') {
                        displayText = line.toUpperCase();
                     } else if (element.textTransform === 'lowercase') {
                        displayText = line.toLowerCase();
                     } else if (element.textTransform === 'capitalize') {
                        displayText = line.charAt(0).toUpperCase() + line.slice(1);
                     }

                     if (element.textAlign === 'center') {
                        textX = x + element.width / 2;
                        textOptions.align = 'center';
                     } else if (element.textAlign === 'right') {
                        textX = x + element.width - (element.padding || 0);
                        textOptions.align = 'right';
                     }

                     if (element.letterSpacing && element.letterSpacing !== 0) {
                        textOptions.charSpace = element.letterSpacing;
                     }

                     const textY = y + (element.padding || 0) + verticalOffset + index * actualLineHeight + fontSize;
                     doc.text(displayText, textX, textY, textOptions);
                  });
               }
            });
         };

         // Function to render table with pagination
         const renderTableWithPagination = (element) => {
            const x = element.x;
            const y = element.y;
            const fields = element.tableFields;
            const rows = setupPrintSingle || [];
            const rowHeight = 20;
            const headerHeight = 20;

            // Calculate dynamic row heights for pagination
            const calculateRowHeights = (rows) => {
               return rows.map((row) => {
                  const cellHeights = fields.map((field) => {
                     const cellValue = row[field.id] || field.placeholder;
                     const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                     // Split text by \n to handle line breaks
                     const lines = textValue.split('\n');
                     const lineHeight = field.fontSize * 1.2;

                     // Calculate wrapped lines for each line
                     const fieldWidth = (element.width * field.width) / 100;
                     const maxWidth = fieldWidth - field.padding * 2;

                     let totalLines = 0;
                     lines.forEach((line) => {
                        // Use jsPDF's splitTextToSize to get accurate line count
                        doc.setFontSize(field.fontSize);
                        const wrappedLines = doc.splitTextToSize(line, maxWidth);
                        totalLines += wrappedLines.length;
                     });

                     return Math.max(rowHeight, totalLines * lineHeight + field.padding * 2);
                  });

                  return {
                     row,
                     height: Math.max(...cellHeights),
                  };
               });
            };

            // Calculate row heights for all rows
            const rowsWithHeights = calculateRowHeights(rows);

            // Split rows into pages based on available height
            const availableHeight = element.height - headerHeight;
            const pageGroups = [];
            let currentPageRows = [];
            let currentPageHeight = 0;

            rowsWithHeights.forEach((rowInfo) => {
               if (currentPageHeight + rowInfo.height > availableHeight && currentPageRows.length > 0) {
                  // Current row doesn't fit, start new page
                  pageGroups.push(currentPageRows);
                  currentPageRows = [rowInfo];
                  currentPageHeight = rowInfo.height;
               } else {
                  currentPageRows.push(rowInfo);
                  currentPageHeight += rowInfo.height;
               }
            });

            // Add remaining rows
            if (currentPageRows.length > 0) {
               pageGroups.push(currentPageRows);
            }

            const totalPages = pageGroups.length;

            for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
               if (pageIndex > 0) {
                  // Add new page for additional table content
                  doc.addPage();
                  // Render static content on new page
                  renderStaticContent(pageIndex + 1);
               }

               const currentPageRowsData = pageGroups[pageIndex];
               const currentPageRows = currentPageRowsData.map((rowInfo) => rowInfo.row);

               // Set drawing properties for table borders
               doc.setDrawColor(0, 0, 0);
               doc.setLineWidth(1);

               let currentY = y;

               // Draw headers on each page
               let currentX = x;
               fields.forEach((field) => {
                  const fieldWidth = (element.width * field.width) / 100;

                  doc.setFontSize(element.headerStyle?.fontSize || 12);
                  doc.setFont(undefined, element.headerStyle?.fontWeight || 'bold');

                  doc.setFillColor(248, 249, 250);
                  doc.rect(currentX, currentY, fieldWidth, headerHeight, 'FD');

                  doc.setTextColor(0, 0, 0);
                  doc.text(field.label, currentX + field.padding, currentY + 15);
                  currentX += fieldWidth;
               });

               currentY += headerHeight;

               // Calculate dynamic row heights based on content
               const rowData = currentPageRows
                  .map((row, rowIndex) => {
                     return currentPageRowsData.find((rowInfo) => rowInfo.row === row);
                  })
                  .map((rowInfo, rowIndex) => {
                     const { row, height: dynamicRowHeight } = rowInfo;

                     const cellHeights = fields.map((field) => {
                        const cellValue = row[field.id] || field.placeholder;
                        const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                        // Split text by \n to handle line breaks
                        const lines = textValue.split('\n');
                        const lineHeight = field.fontSize * 1.2; // Line height factor

                        return {
                           lines,
                           height: dynamicRowHeight,
                           lineHeight: lineHeight,
                        };
                     });

                     return {
                        row,
                        rowIndex,
                        height: dynamicRowHeight,
                        cellData: cellHeights,
                     };
                  });

               // Draw current page rows with dynamic heights
               rowData.forEach((rowInfo) => {
                  const { row, rowIndex, height: dynamicRowHeight, cellData } = rowInfo;

                  currentX = x;
                  fields.forEach((field, fieldIndex) => {
                     const fieldWidth = (element.width * field.width) / 100;

                     doc.setFontSize(field.fontSize);
                     doc.setFont(undefined, field.fontWeight);

                     // Draw cell background
                     if (element.alternateRowColors && rowIndex % 2 === 1) {
                        doc.setFillColor(245, 245, 245);
                        doc.rect(currentX, currentY, fieldWidth, dynamicRowHeight, 'FD');
                     } else {
                        doc.setFillColor(255, 255, 255);
                        doc.rect(currentX, currentY, fieldWidth, dynamicRowHeight, 'FD');
                     }

                     doc.setTextColor(0, 0, 0);

                     // Get cell data for this field
                     const cellInfo = cellData[fieldIndex];
                     const { lines, lineHeight } = cellInfo;

                     // Calculate text position
                     let textX = currentX + field.padding;
                     if (field.alignment === 'center') {
                        textX = currentX + fieldWidth / 2;
                     } else if (field.alignment === 'right') {
                        textX = currentX + fieldWidth - field.padding;
                     }

                     // Track current Y position for proper line spacing
                     let currentLineY = currentY + field.padding + field.fontSize;

                     // Draw each line of text with proper spacing
                     lines.forEach((line, lineIndex) => {
                        // Handle text wrapping if line is too long
                        const maxWidth = fieldWidth - field.padding * 2;
                        const wrappedLines = doc.splitTextToSize(line, maxWidth);

                        wrappedLines.forEach((wrappedLine, wrappedIndex) => {
                           doc.text(wrappedLine, textX, currentLineY, {
                              align:
                                 field.alignment === 'center'
                                    ? 'center'
                                    : field.alignment === 'right'
                                       ? 'right'
                                       : 'left',
                              maxWidth: maxWidth,
                           });

                           // Move to next line position
                           currentLineY += lineHeight;
                        });
                     });

                     currentX += fieldWidth;
                  });
                  currentY += dynamicRowHeight;
               });

               // Draw outer table border with actual used height
               const actualTableHeight = headerHeight + rowData.reduce((sum, rowInfo) => sum + rowInfo.height, 0);
               doc.setDrawColor(0, 0, 0);
               doc.setLineWidth(1);
               doc.rect(x, y, element.width, actualTableHeight, 'S');

               if (element.showColumnLines) {
                  let columnX = x;
                  fields.forEach((field, fieldIndex) => {
                     if (fieldIndex < fields.length - 1) {
                        // Don't draw line after last column
                        const fieldWidth = (element.width * field.width) / 100;
                        columnX += fieldWidth;

                        // Draw vertical line for the column
                        doc.setDrawColor(
                           field.borderColor ? hexToRgb(field.borderColor)[0] : 226,
                           field.borderColor ? hexToRgb(field.borderColor)[1] : 232,
                           field.borderColor ? hexToRgb(field.borderColor)[2] : 240,
                        );
                        doc.setLineWidth(field.borderWidth || 1);
                        doc.line(columnX, y, columnX, y + actualTableHeight);
                     }
                  });
               }

               // Add page number if multiple pages
               if (totalPages > 1) {
                  doc.setFontSize(10);
                  doc.setTextColor(128, 128, 128);
                  doc.text(
                     `Page ${pageIndex + 1} of ${totalPages}`,
                     x + element.width - 50,
                     y + actualTableHeight + 15,
                  );
               }
            }
         };

         // Render static content on first page
         renderStaticContent(1);

         // Process each table element
         tableElements.forEach((element) => {
            if (element.type === 'table' && element.tableFields) {
               renderTableWithPagination(element);
            }
         });

         toast({
            title: 'PDF Generated',
            description: 'Invoice format has been exported successfully!',
            status: 'success',
            duration: 3000,
            isClosable: true,
         });

         return doc.output('blob');
      } catch (error) {
         console.error('PDF generation failed:', error);
         toast({
            title: 'Export Failed',
            description: error.message || 'Failed to generate PDF. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         throw error;
      } finally {
         setIsGenerating(false);
      }
   };

   return {
      generatePDFBlob,
      previewElements,
      setPreviewElements,
      isGenerating,
   };
};